import * as React from 'react';
import { tokens } from 'src/design-system';

export default ({ containerDetails, getContainerType }) => {
  if (containerDetails.length >= 2) {
    const [
        { count: count1, size: size1, type: type1 },
        { count: count2, size: size2, type: type2 },
    ] = containerDetails;
    return (
        <>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count1}</span>
                &nbsp;X&nbsp;
                {size1} {getContainerType(type1)}
            </div>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count2}</span>
                &nbsp;X&nbsp;
                {size2} {getContainerType(type2)}
            </div>
            <div
              style={{
                textAlign: 'center',
                color: '#262626',
                fontSize: `${tokens.fontSize.caption}px`,
                fontWeight: tokens.fontWeight.semibold,
              }}>
                {
                  containerDetails.length > 2 ?
                    `+${containerDetails.length - 2} More`
                    : ''
                }
            </div>
        </>
    );
  }
  if (containerDetails.length === 1) {
    const [{ count, size, type }] = containerDetails;
    return (
        <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px', textAlign: 'center' , padding: '10px'}}>
            <span style={{ fontWeight: 600 }}>{count}</span>
            &nbsp;X&nbsp;
            {size} {getContainerType(type)}
        </div>
    );
  }
  return null;
};
